module.exports = __webpack_public_path__ + "static/media/Hbook-16.fc3c9dd1.jpg";